import { useEffect, type ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

interface Props {
  title: string
  icon: LucideIcon
  phase: string
  description: ReactNode
}

/**
 * Shared placeholder used by Users / Stats / Logs / Profile in Phase 1.
 * Each page lands on a clear "coming in Phase N" frame so the sidebar
 * doesn't dead-end at a blank screen, and so future Phase work has an
 * obvious component to replace.
 */
export function StubPage({ title, icon: Icon, phase, description }: Props) {
  useEffect(() => { document.title = title }, [title])
  return (
    <div className="p-6 max-w-3xl">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded bg-primary-50 text-primary-600 flex items-center justify-center">
          <Icon className="w-5 h-5" />
        </div>
        <div>
          <h1 className="page-title">{title}</h1>
          <p className="text-xs text-gray-500 mt-0.5">{phase}</p>
        </div>
      </div>

      <div className="card p-5 bg-amber-50 border-amber-200 text-sm text-amber-900">
        {description}
      </div>
    </div>
  )
}
